import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { environment } from '../../../environments/environment';
import { MongoResource } from '../../shared/mongo.resource';
import { Chats, Message } from './chats.model';
import { HttpClient } from '@angular/common/http';

// @Injectable()
// export class AnnouncementsService {

//     constructor() { }

// }

@Injectable()
export class ChatsService extends MongoResource<any, any, any> {

  baseUrl = environment.api + 'chats';
  constructor(public http: HttpClient) { super(http); }

  getMessages(id: string): Observable<any[]> {
    return this.$get(id);
  }
  public createMessage(_id: string, action: string, message: any) {
    return this.$post(_id + '/' + action, message);
  }
}



// WEBPACK FOOTER //
// /ng-app/src/app/chats/shared/chats.service.ts